import React, { useEffect } from 'react';

const LMSPage = () => {
  useEffect(() => {
    // Redirect to the external LMS site
    window.location.href = 'https://lms.stemlabs.edu.lk/';
  }, []);

  return (
    <div className="container py-16 flex flex-col items-center justify-center min-h-[60vh]">
      <h1 className="text-3xl font-bold mb-6">Redirecting to LMS...</h1>
      <p>You are being redirected to the STEM Labs Learning Management System.</p>
      <p>If you are not redirected automatically, please click <a href="https://lms.stemlabs.edu.lk/" className="text-theme-accent hover:underline">here</a>.</p>
    </div>
  );
};

export default LMSPage; 